"use client"

import type React from "react"
import { useState } from "react"
import { ChevronDown, ChevronUp } from "lucide-react"

export const DataSourceInfo: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="mt-8 border-t border-gray-200 pt-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-between w-full text-left text-sm text-blue-600 hover:underline focus:outline-none bg-transparent"
      >
        <span>Datakällor och metodik</span>
        {isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
      {isExpanded && (
        <div className="mt-2 text-sm text-gray-600 space-y-2">
          <p>
            All data som presenteras på den här sidan kommer från Skolverkets officiella statistik. Skolenkäten som
            redovisas här är den som utförs av Skolinspektionen.
          </p>
          <p>
            Resultat från Skolenkäten är från det senaste
            tillgängliga året. Notera att detta kan variera mellan skolor, eftersom enkäten genomförs vartannat år för
            samtliga skolor.
          </p>
          <p>
            För antalet elever per lärare så är alla årskurser inräknade, dvs inklusive F-klass. Dock ingår ej
            fritidspersonal. 
          </p>
          <p>Vi strävar efter att redovisa den senast tillgängliga informationen. I dagsläget redovisas data från läsåret 2023/2024, förutom data på elever och lärare som är från läsåret 2024/2025 - om inte annat anges, tex där vi redovisar 3 års historik.</p>
          <p>
            Värden som saknas anges som n/a eller att data saknas. Detta kan bero på att data inte existerar, eller att dataunderlaget är för
            litet för att redovisas av Skolverket.
          </p>
        </div>
      )}
    </div>
  )
}

